import { isEmpty, orderBy } from 'lodash'
import { useEffect, useState } from 'react'
import getCollection from '../../utils/db/getCollection'
import Icon from '../../ui/Icon/Icon'
import './ServicePrice.sass'

function ServicePrice() {
  const services = [
    { title: `Покос травы`, quantity: `1 сотка`, price: `от 700 руб` },
    { title: `Стрижка кустарников`, quantity: `1`, price: `от 500 руб` },
    { title: `Спил деревьев`, quantity: `1`, price: `от 500 руб` },
    { title: `Вывоз деревьев`, quantity: `1`, price: `от 500 руб` },
    { title: `Вывоз травы в мешках`, quantity: `1 мешок`, price: `50 руб` },
    { title: `Выезд в область`, quantity: `1 км`, price: `15 руб` },
  ]

  return (
    <div className="ServicePrice">
      {!isEmpty(services) && <ServiceTile services={services} />}
    </div>
  )
}

function ServiceTile({ categoryId, services }) {
  return (
    <div id={`category-${categoryId}`} className={`ServiceTile`}>
      <div className="Tile-Head">
        <span className="Title">Прайс</span>
      </div>

      <div className="Tile-Body">
        <div className="PriceTable">
          <table>
            <thead>
              <tr>
                <th>Услуга</th>
                <th>Ед. от</th>
                <th className="Price">Стоимость, руб</th>
              </tr>
            </thead>
            <tbody>
              {services.map((s) => (
                <tr key={s.serviceId}>
                  <td>{s.title}</td>
                  <td>{s.quantity}</td>
                  <td className="Price">{s.price} руб</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}

export default ServicePrice
